module.exports = __webpack_public_path__ + "src/styles/logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/logo.png
// module id = 239
// module chunks = 1